module.exports = __webpack_public_path__ + "static/media/logomark_primary.7e47519f.svg";